import React, { useState } from 'react';
import DataTable from '@/common/tableData/DataTable';
import { AiOutlineEdit } from 'react-icons/ai';
import DebouncedInput from '@/components/DebounceInput';
import useBlindStructures from '@/hooks/useBlindStructures';

const BlindStructureTable = ({ onSelectBlindStructure }: { onSelectBlindStructure: (id: string) => void }) => {
  const [search, setSearch] = useState('');

  const { blindStructures } = useBlindStructures();

  if (!blindStructures) {
    return null;
  }

  return (
    <div className="d-flex flex-column gap-3 py-2">
      <div className="w-100 d-flex justify-content-start align-items-center gap-2 py-2">
        <DebouncedInput
          className="form-control w-auto"
          placeholder="Search"
          isLoading={false}
          onChange={(val) => setSearch(val as string)}
          value={search}
        />
      </div>
      <DataTable
        data={blindStructures}
        onRowClick={(row) => onSelectBlindStructure(row.id)}
        columnFilters={[
          {
            id: 'name',
            value: search,
          },
        ]}
        columns={[
          {
            header: 'Actions',
            size: 50,
            cell: ({ row }) => (
              <div className="d-flex justify-content-start w-full flex-row">
                <AiOutlineEdit
                  size={20}
                  onClick={() => onSelectBlindStructure(row?.original.id)}
                  className="cursor-pointer"
                />
              </div>
            ),
          },
          {
            header: 'Name',
            accessorKey: 'name',
            size: 290,
            filterFn: 'includesString',
          },
          {
            header: 'Levels',
            accessorKey: 'levels',
            size: 260,
            cell: ({ row }) => (
              <div className="d-flex justify-content-start w-full text-left">{row.original.levels.length}</div>
            ),
          },
        ]}
      />
    </div>
  );
};

export default BlindStructureTable;
